import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HomePageComponent } from './home-page/home-page.component';
import { SearchHomeComponent } from './search-home/search-home.component';
import { HomeSelectionComponent } from './home-selection/home-selection.component';
import { ProductSelectionComponent } from './product-selection/product-selection.component';
import { ActuComponent } from './actu/actu.component';
import { UiModule } from '../../ui/ui.module';
import { PartialModule } from '@components/page/partial/partial.module';
// import { HomeAnimComponent } from './home-anim/home-anim.component';
import { AnimListComponent } from './anim-list/anim-list.component';
import { HomeIntroAnimComponent } from './home-intro-anim/home-intro-anim.component';
import { AnimShopComponent } from './anim-shop/anim-shop.component';
import { AnimShopPhoneComponent } from './anim-shop-phone/anim-shop-phone.component';
import { TournamentsComponent } from './tournaments/tournaments.component';
import { TournamentsPhoneComponent } from './tournaments-phone/tournaments-phone.component';
import { FestivalsComponent } from './festivals/festivals.component';
import { NextFestivalComponent } from './next-festival/next-festival.component';
import { GoldnGobComponent } from './goldn-gob/goldn-gob.component';


@NgModule({
  declarations: [
    HomePageComponent,
    SearchHomeComponent,
    HomeSelectionComponent,
    ProductSelectionComponent,
    HomeIntroAnimComponent,
    ActuComponent,
    // HomeAnimComponent,
    AnimListComponent,
    HomeIntroAnimComponent,
    AnimShopComponent,
    AnimShopPhoneComponent,
    TournamentsComponent,
    TournamentsPhoneComponent,
    FestivalsComponent,
    NextFestivalComponent,
    GoldnGobComponent
  ],
  imports: [
    CommonModule,
    UiModule,
    RouterModule,
    PartialModule
  ],
  exports: [
    HomePageComponent
  ]
})
export class HomeModule { }
